import captureException from 'src/common/utils/captureException';
import { apiRequest } from 'src/common/utils/apiFetch';

const getInstabookDates = async (
  listingId: string,
  startDate: string,
  endDate: string,
): Promise<string[]> => {
  let dates: string[] = [];
  const url = `/api/v4/instabook/availability_dates_only/?boat_id=${listingId}&start_date=${startDate}&end_date=${endDate}`;
  try {
    const response = await apiRequest(url);
    if (response.status === 200) {
      dates = await response.json();
    }
  } catch (error) {
    // TODO: handle error
    captureException(error);
  }
  return dates;
};

export default getInstabookDates;
